module.exports = __webpack_public_path__ + "img/US_SightRange_ua.980f1717.webp";